var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weight"},[_c('h2',[_vm._v("Encumberance")]),_c('h1',[_vm._v(_vm._s(_vm.inventory.weight)+" lbs")])])}
var staticRenderFns = []

export { render, staticRenderFns }